export enum StatusEnum {
  DEPOSIT = '1',
  PUBLISHED = '2',
  TO_CORRECT = '3',
  ARCHIVED = '4',
}
